var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.98417 0.493164C3.10255 0.493164 2.30532 0.713507 1.72667 1.25082C1.14253 1.79325 0.845215 2.59875 0.845215 3.63212V7.45345C0.845215 8.48685 1.14253 9.29233 1.72667 9.83474C2.30532 10.3721 3.10255 10.5924 3.98417 10.5924H9.44321C10.3248 10.5924 11.1221 10.3721 11.7007 9.83474C12.2849 9.29233 12.5822 8.48685 12.5822 7.45345V3.63212C12.5822 2.59875 12.2849 1.79325 11.7007 1.25082C11.1221 0.713507 10.3248 0.493164 9.44321 0.493164H3.98417ZM10.6598 3.55694C10.8387 3.41869 10.8716 3.16156 10.7333 2.98263C10.5951 2.8037 10.338 2.77073 10.1591 2.90899L7.13087 5.24887C6.88516 5.43879 6.54217 5.43879 6.2964 5.24887L3.26827 2.90899C3.08934 2.77073 2.83221 2.8037 2.69395 2.98263C2.55569 3.16156 2.58865 3.41869 2.76759 3.55694L5.79575 5.89685C6.33641 6.31458 7.09091 6.31458 7.63157 5.89685L10.6598 3.55694Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.0c2feba0780653cb27627e92b2d3b5ac.svg";
export { ForwardRef as ReactComponent };